import { Project } from '~/types/project';

export default function getDisplayValueCosts(project: Project, projectCosts: any) {
  //projectCosts can be an array for sell side fees
  if (projectCosts && Array.isArray(projectCosts) && projectCosts?.length > 0) {
    //match individual projectCost object to the current bid projectId
    
    const projectCost = projectCosts?.find((row: any) => 
      row?.bid?.bidStatus === 'ACCEPTED' || 
      (!project.parentId && row?.bid?.parentProjectId === project?.id) || 
      row?.bid?.projectId === project?.id
    );

    projectCosts = projectCost;
  }  
  return projectCosts;
  
};